exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleOn[data-v-5af82944]{border-radius:10px !important}.title-box[data-v-5af82944]{color:#282828;padding:5px 10px;background-repeat:no-repeat}.ml6[data-v-5af82944]{margin-left:6px}", ""]);

// exports
